/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LearnWorldCourseListResponseModel } from '../../models/learn-world-course-list-response-model';

export interface LearnWorldCoursesGet$Params {
}

export function learnWorldCoursesGet(http: HttpClient, rootUrl: string, params?: LearnWorldCoursesGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<LearnWorldCourseListResponseModel>> {
  const rb = new RequestBuilder(rootUrl, learnWorldCoursesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<LearnWorldCourseListResponseModel>;
    })
  );
}

learnWorldCoursesGet.PATH = '/LearnWorld/Courses';
